import React from 'react';

export default () => (
<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 3H9.75V9.75H3V3ZM14.625 3C16.5 3 18 4.5 18 6.375C18 8.25 16.5 9.75 14.625 9.75C12.75 9.75 11.25 8.25 11.25 6.375C11.25 4.5 12.75 3 14.625 3ZM6.375 12L9.75 18H3L6.375 12ZM15.75 14.25H18V15.75H15.75V18H14.25V15.75H12V14.25H14.25V12H15.75V14.25Z" fill="currentColor"/>
</svg>
);
